import Controller from "./Controller";
import AccountProfileController from "components/Global/Controllers/AccountProfile";

export default AccountProfileController(Controller);
